import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const CLIENT_SEARCH_BY_OPTIONS = gql`
  query ClientSearchByOptions {
    clientSearchByFields
  }
`;

export default function useClientSearchByOptions() {
  const { loading, error, data } = useQuery(CLIENT_SEARCH_BY_OPTIONS, {
    onCompleted: () => {},
    onError: () => {}
  });

  return {
    clientSearchByOptions:
      data?.clientSearchByFields?.map(field => ({
        label: backendNameToLabel(field),
        value: field
      })) || [],
    loading,
    error
  };
}
